<template>
    <div class="comp_confirm_modal_overlay">
        <div
            class="modal_overlay"
            v-bind:class="{ modalShow: is_visible_modal_market_app }"
        >
            <div class="box">
                <header>
                    <h2 class="modal_title">
                        {{ translations.confirm_modal_market.title }}
                    </h2>
                </header>
                <section class="wrapper_inputs">
                    <p class="content">
                        {{ translations.confirm_modal_market.content }}
                    </p>
                    <span
                        class="icon-close-positive-circle close"
                        @click="closeModal"
                    ></span>
                    <span class="line_separator"></span>
                    <span class="wrapper-buttons">
                        <div class="button black30" @click="closeModal">
                            {{ translations.generic.cancel }}
                        </div>
                        <div class="button" @click="changeMarketApp">
                            {{ translations.generic.accept }}
                        </div>
                    </span>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import App from './../application.js'

export default {
    data: function () {
        return {
            is_visible_modal_language_app: false,
            is_visible_modal_market_app: false,
            current_language_selected: '',
            default_language_selected: '',
            current_market_selected: '',
            default_market_selected: '',
            translations: {
                generic: App.current_translations['generic'],
                confirm_modal_language: App.current_translations['confirm_modal_language'],
                confirm_modal_market: App.current_translations['confirm_modal_market']
            }
        }
    },
    mounted: function () {
        var self = this;
        App.bus.$on('confirmChangeLanguageModal', function (obj) {
            self.current_language_selected = obj.current_language_selected;
            self.default_language_selected = obj.default_language_selected;
            self.is_visible_modal_language_app = true;
        });
        App.bus.$on('confirmChangeMarketModal', function (obj) {
            self.current_market_selected = obj.current_market_selected;
            self.default_market_selected = obj.default_market_selected;
            self.is_visible_modal_market_app = true;
        });
    },
    methods: {
        closeModal: function () {
            this.is_visible_modal_language_app = false;
            this.is_visible_modal_market_app = false;
        },
        changeMarketApp: function () {
            App.unex_lib.setMarketSolutions(this.current_market_selected);
            App.unex_lib.setDefaultMarketSolutions(this.default_market_selected);
            this.is_visible_modal_market_app = false;
            App.bus.$emit('saveChangeMarketApp', this.current_market_selected, this.default_market_selected);
            App.bus.$emit('clean_loaded_query');
        }
    }
}
</script>

<style>
</style>